<template>
  <div class="imDirectory">
      <im-top></im-top>
    <div class="content">
      <div>
        <img src="../../assets/workorder/all.png">
        <span>请选择你要咨询的问题类型</span>
      </div>
      <p v-for="(item,index) in entranceList" :key="index">
        <a href="javascript:;" @click="setEntrance(item.id)">{{item.name}}</a>
      </p>
    </div>
  </div>
</template>

<script>
import imTop from '../im/IMTop.vue'
import {mapGetters} from 'vuex'
export default {
name: 'ImDirectory',
components:{
    imTop
  },
  data () {
    return {
      //allquestion:["账号类","充值类","被盗类","咨询类"],
    }
  },
  computed: {
      ...mapGetters({
        entranceList: 'getEntranceList',
      })
  },
  mounted(){
     var gois=true;
     var userAgent = navigator.userAgent;
     if(userAgent.indexOf("Windows")>-1){
        if (/Safari/.test(navigator.userAgent) && !/Chrome/.test(userAgent)) {
             console.log(userAgent)
             gois=false;
        }
    }
    if(gois){
      this.renderPage();
    }else{
      this.$router.push('/beatis')
    }
  },
  methods:{
    renderPage () {
      var vm = this;
      let visitorMd5Code = sessionStorage.md5; //
      this.$store.dispatch({
        type:'entrance',
        router: vm.$router,
        visitorMd5Code: visitorMd5Code
      })
    },
    setEntrance (entranceId) {
      //alert("1213")
      this.$store.commit('setEntranceId',entranceId);
      sessionStorage.setItem("entranceId", entranceId)
      this.$router.replace({path:'/imLineUp'});
    }
  }
}
</script>

<style scoped>
  .content{
    width: 560px;
    overflow: hidden;
    border-radius: 6px;
    border:1px solid #cccccc;
    background: #ffffff;
    margin:0 auto;
    margin-top: 30px;
  }
  .content div{
    width: 100%;
    height: 40px;
    text-align: left;
    border-bottom: 1px solid #cccccc;
  }
  .content div img{
    display: block;
    float: left;
    width: 26px;
    height: 26px;
    margin-left: 18px;
    margin-top: 8px;
  }
  .content div span{
     display: block;
    float: left;
    font-size: 14px;
    color: #000;
    font-weight: bold;
    margin-top: 12px;
    margin-left: 14px;
  }
  .content p{
    width: 240px;
    height: 40px;
    float: left;
    text-align: center;
    line-height: 48px;

    font-size: 14px;
  }
  .content p a{
    color: #5987c2;
  }
 .workerorderindex{
  background: #f8f8f8;
  width: 100%;
  height: 100%;
 }
</style>



// WEBPACK FOOTER //
// src/components/im/imDirectory.vue?6bb76f5e